import React from 'react';
import ReactDom from 'react-dom';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import InstrumentPerformance from './components/InstrumentPerformance/InstrumentPerformance';

const rootElement = document.getElementById('instrumentPerformance');

ReactDom.render(
    <InstrumentPerformance
        initialState={rootElement.dataset.initialstate}
    />,
    rootElement,
);
